import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('qposm_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401/403 responses globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem('qposm_token');
      localStorage.removeItem('qposm_user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Resolve a backend-relative URL (e.g. "/api/auth/logo-image/3?ts=...") into
// an absolute URL the browser can load. Useful for <img src="..."> where axios
// can't intercept.
export function resolveBackendUrl(pathOrUrl) {
  if (!pathOrUrl) return null;
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;
  const host = API_BASE_URL.replace(/\/api\/?$/i, '');
  // Path may start with "/api/..." (absolute on backend) or just "/..."
  return `${host}${pathOrUrl.startsWith('/') ? '' : '/'}${pathOrUrl}`;
}

export default api;
